import { render, staticRenderFns } from "./ActiveViewSectionHeader.vue?vue&type=template&id=a4dc95a4&scoped=true"
import script from "./ActiveViewSectionHeader.vue?vue&type=script&lang=js"
export * from "./ActiveViewSectionHeader.vue?vue&type=script&lang=js"
import style0 from "./ActiveViewSectionHeader.vue?vue&type=style&index=0&id=a4dc95a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dc95a4",
  null
  
)

export default component.exports